import axios from 'axios';
import { baseUrl, HttpMethods } from '../../../../base';
import type {
  IGetDeliverablesService,
  IGetDeliverablesServiceRes,
  IGetMilestonesService,
  IGetMilestonesServiceRes,
  IGetTasksService,
  IGetTasksServiceRes,
  IGetTDMsService,
  IGetTDMsServiceRes,
} from './types';

export async function getTDMs({ projectId }: IGetTDMsService): Promise<IGetTDMsServiceRes> {
  const res = await axios.request<IGetTDMsServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/projects/${projectId}/activities`,
  });
  return res.data;
}

export async function getTasks({ params }: IGetTasksService): Promise<IGetTasksServiceRes> {
  const res = await axios.request<IGetTasksServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/tasks`,
    params,
  });
  return res.data;
}

export async function getDeliverables({ params }: IGetDeliverablesService): Promise<IGetDeliverablesServiceRes> {
  const res = await axios.request<IGetDeliverablesServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/deliverables`,
    params,
  });
  return res.data;
}

export async function getMilestones({ params }: IGetMilestonesService): Promise<IGetMilestonesServiceRes> {
  const res = await axios.request<IGetMilestonesServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/milestones`,
    params,
  });
  return res.data;
}
